const kcColors = {
  white: '#FFFFFF', // background of cards, inputs, selects
  blackBlue: '#132B45', // primary text color, secondary-button text

  yellow: '#C49312', // accent color of text, focus outline
  gold: '#A48C5D', // primary (action) button background
  paleGold: '#DBCFBB', // checkbox border

  green: '#006351', // some header titles

  paleGray: '#D2D5DC', // secondary-button border
  greyish: '#516170', // footer subtitle / chip text
  background: '#F4F5F7', // page background

  // belows are derived from RTI tokens
  gray: '#999999', // used alongside "greyish"
  lightGray: '#E6E6E6',
  delimiterGray: '#F5F5F5',
  tableHover: '#FAFAFA', // table row hover background

  beige: '#F5F4EB',
  yellowHighlighter: '#FEEFB2',

  redError: '#E02020',
  paleRedError: '#EF8F8F',
  redErrorBg: '#FFD9D9',

  successGreen: '#34A853',
  greenBg: '#DAF2E0',
} as const;

export default kcColors;
